import { Nullable } from "../../globals/types";
import moment from "moment";

export function makeCreationAreaDto(formData: FormData): CreationAreaDto {
    const formDataObject: any = Object.fromEntries(
        Array.from(formData).filter(([_, v]) => v != null && v !== ""));

    let soilWorkStartDate = null;
    if (formDataObject.soilWorkStartDate !== undefined) {
        soilWorkStartDate = moment(formDataObject.soilWorkStartDate, "DD.MM.YYYY").format("YYYY-MM-DD");
    }

    let soilWorkEndDate = null;
    if (formDataObject.soilWorkEndDate !== undefined) {
        soilWorkEndDate = moment(formDataObject.soilWorkEndDate, "DD.MM.YYYY").format("YYYY-MM-DD");
    }

    let afterSoilApplicationAcceptanceDate = null;
    if (formDataObject.afterSoilApplicationAcceptanceDate !== undefined) {
        afterSoilApplicationAcceptanceDate = moment(formDataObject.afterSoilApplicationAcceptanceDate, "DD.MM.YYYY").format("YYYY-MM-DD");
    }

    let cultivationEndDate = null;
    if (formDataObject.cultivationEndDate !== undefined) {
        cultivationEndDate = moment(formDataObject.cultivationEndDate, "DD.MM.YYYY").format("YYYY-MM-DD");
    }

    let afterCultivationAcceptanceDate = null;
    if (formDataObject.afterCultivationAcceptanceDate !== undefined) {
        afterCultivationAcceptanceDate = moment(formDataObject.afterCultivationAcceptanceDate, "DD.MM.YYYY").format("YYYY-MM-DD");
    }

    return {
        ...formDataObject,
        soilWorkStartDate: soilWorkStartDate,
        soilWorkEndDate: soilWorkEndDate,
        afterSoilApplicationAcceptanceDate: afterSoilApplicationAcceptanceDate,
        cultivationEndDate: cultivationEndDate,
        afterCultivationAcceptanceDate: afterCultivationAcceptanceDate
    }
}

export type CreationAreaDto = {
    id: number;
    extId: Nullable<number>;
    fffCreationProjectId: number;
    adjustFFFDataCollection: boolean;
    areaExact: number;
    areaRounded: number;
    effectiveAreaRounded: number;
    nek: number;
    stage: Nullable<number>;
    png: Nullable<number>;
    eligibility: number;
    creationStatus: Nullable<string>;
    soilWorkStartDate: Nullable<string>;
    soilWorkEndDate: Nullable<string>;
    afterSoilApplicationAcceptanceDate: Nullable<string>;
    cultivationEndDate: Nullable<string>;
    afterCultivationAcceptanceDate: Nullable<string>;
    afterSoilApplicationDocStatus: Nullable<string>;
    afterSoilApplicationDocSource: Nullable<string>;
    afterCultivationDocStatus: Nullable<string>;
    afterCultivationDocSource: Nullable<string>;
    remarksProjectStatus: Nullable<string>;
    remarksDocumentation: Nullable<string>;
}

export type UsageAreaDto = {
    id: number;
    fffUsageProjectId: number;
    adjustFFFDataCollection: boolean;
    areaExact: number;
    areaRounded: number;
    effectiveAreaRounded: number;
    areaNEK2: Nullable<number>;
    areaNEK3: Nullable<number>;
    areaNEK4: Nullable<number>;
    areaNEK5: Nullable<number>;
    areaNEK6: Nullable<number>;
    areaNEKUnknown: Nullable<number>;
    effectiveAreaNEK2Rounded: Nullable<number>;
    effectiveAreaNEK3Rounded: Nullable<number>;
    effectiveAreaNEK4Rounded: Nullable<number>;
    effectiveAreaNEK5Rounded: Nullable<number>;
    effectiveAreaNEK6Rounded: Nullable<number>;
    effectiveAreaNEKUnknownRounded: Nullable<number>;
    eligibility: number;
}